import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useHandleNotifications(userId) {
  const { data, error, mutate } = useSWR(`${apiBaseURL}/api/Notifications`, {
    onSuccess: (data) =>
      console.log("Notifications fetched successfully:", data?.data),
    revalidateOnFocus: false,
    dedupingInterval: 300000,
  });

  return {
    notificationData: data?.data,
    error,
    mutate,
  };
}
